export default __webpack_public_path__ + "static/media/P6.c5275f59.png";